import React from "react";
import { useSelector } from "react-redux";
import { S3_BASE_URL } from "../../../../Service";

const BannerDefault = () => {
  const banner = useSelector((state) => state.data.banner);

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "";
    return imagePath.startsWith("http")
      ? imagePath
      : `${S3_BASE_URL}/${imagePath}`;
  };

  return (
    <React.Fragment>
      <div
        className="rs-banner style1"
        style={{
          backgroundImage: banner
            ? `url(${getImageUrl(banner.bannerImage)})`
            : "url(../img/banner/Frame4.svg)",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="banner-height pt-100 pb-100 md-pt-80 md-pb-80">
          <div className="container">
            <div className="row align-items-center">
              {/* Left Side Content */}
              <div className="col-lg-7 col-md-12 pt-40 pr-140 md-pt-0 md-mb-60 md-pr-14">
                <div className="banner-content">
                  {banner ? (
                    <>
                      <h2
                        className="bnr-title"
                        data-animation="fadeInLeft"
                        data-delay=".3s"
                      >
                        {banner.heading}
                      </h2>
                      <p
                        className="bnr-desc"
                        data-animation="fadeInLeft"
                        data-delay=".5s"
                      >
                        {banner.subheading}
                      </p>
                    </>
                  ) : (
                    <p>Loading...</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BannerDefault;
